import React from 'react';
const FormProgress = ({ currentStep }) => {
    let steps = [window.translations.reservationExternal.steps.personalInfo, "Doplňky", window.translations.reservationExternal.steps.summary];

    const progress = steps.map((step, index) => {
        return (
            <div key={index} className={`mt-2 form-progress__step text-center py-3 text-uppercase ${index+1 == currentStep ? 'form-progress__step--active' : ''}`}>
                <div>{index + 1}.&nbsp;{step}</div>
            </div>
        );
    });

    return (
        <div className="form-progress d-flex justify-content-between">
            {progress}
        </div>
    );
}

export default FormProgress;